import type { GameKindAdapter } from "../shared/adapter";
import { compileEndlessRunner } from "./compiler";
import { evaluateEndlessRunner } from "./evaluator";
import { repairCommandsForEndlessRunner } from "./repair";
import { parseEndlessRunnerSpec, type EndlessRunnerSpec } from "./spec";

export const endlessRunnerAdapter: GameKindAdapter = {
  kind: "endless-runner",
  briefHints: ["endless runner", "flappy", "dino run", "auto-run", "jump over obstacles", "side-scroller"],
  promptSchemaLine:
    '{"kind":"endless-runner","params":{"worldWidth":960,"worldHeight":540,"gravity":integer 900-2400,"jumpVelocity":integer 400-1000,"obstacleSpeed":integer 220-600,"obstacleWidth":integer 20-60,"minGapSeconds":integer 1-4,"obstacleCount":integer 10-40,"speedRampPercent":integer 0-40 (how much faster the last obstacle moves; 20-30 feels exciting),"playerGlyph":"one emoji for the runner, e.g. \\"🦖\\" or \\"🐱\\"","obstacleGlyph":"one emoji for what is dodged, e.g. \\"🌵\\" or \\"🪨\\""}}',
  parseSpec: parseEndlessRunnerSpec,
  compile: (spec) => compileEndlessRunner(spec as EndlessRunnerSpec),
  evaluate: (spec) => evaluateEndlessRunner(spec as EndlessRunnerSpec),
  repairCommandsFor: (spec, failedReceipt) => repairCommandsForEndlessRunner(spec as EndlessRunnerSpec, failedReceipt),
};

export type { EndlessRunnerSpec } from "./spec";
